import { ReactNode } from 'react';

import classNames from 'classnames';

import { PreviewButtons } from './Buttons';
import { useStyles } from './Preview.styles';

/**
 * Свойства компонента {@link DownloadableFileIcon}
 */
interface DownloadableFileIconProps {
  /**
   * Форма компонента ('auto' или 'square').
   */
  shape: 'auto' | 'square';

  /**
   * Иконка файла.
   */
  children: ReactNode;

  /**
   * Функция, вызываемая при нажатии кнопки загрузки файла.
   */
  onClickDownload?: () => Promise<
    Blob | { file: Promise<Blob>; filename?: string }
  >;

  /**
   * Флаг, указывающий наличие сворачиваемого нижнего колонтитула.
   */
  withCollapsableFooter?: boolean;
}

/**
 * Компонент для отображения иконки файла с кнопкой скачивания.
 *
 * @internal
 * @param shape - Форма компонента ('auto' или 'square').
 * @param children - Иконка файла.
 * @param onClickDownload - Функция, вызываемая при нажатии кнопки загрузки файла.
 * @param withCollapsableFooter - Флаг, указывающий наличие сворачиваемого нижнего колонтитула.
 * @returns  Возвращает элемент React с иконкой файла и кнопкой скачивания.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link DownloadableFileIconProps}
 */
export const DownloadableFileIcon = ({
  shape,
  children,
  onClickDownload,
  withCollapsableFooter,
}: DownloadableFileIconProps) => {
  const { classes } = useStyles({});

  return (
    <div
      className={classNames(
        classes.root,
        classes.collapseWrapper,
        classes.previewDocx,
      )}
    >
      {shape === 'square' && <div className={classes.square} />}
      <div className={classes.docImage}>{children}</div>
      {onClickDownload && (
        <PreviewButtons
          onClickDownload={onClickDownload}
          withCollapsableFooter={withCollapsableFooter}
          clickable
        />
      )}
    </div>
  );
};
